import { z } from 'zod';

// Page-scoped edge liveness probe. The SPA writes { req_nonce, req_at_ms } while
// the Master page is open; the Edge Agent answers by pinging the master and
// writing { resp_nonce, online, resp_at_ms, error }. Edge-written fields are
// nullable so a fresh request doc parses.
// Spec: docs/superpowers/specs/2026-06-29-edge-probe-master-status-design.md
export const EdgeProbeSchema = z.object({
  req_nonce: z.string().min(1),
  req_at_ms: z.number(),
  resp_nonce: z.string().nullable().default(null),
  online: z.boolean().nullable().default(null),
  resp_at_ms: z.number().nullable().default(null),
  error: z.string().nullable().default(null),
});

export type ParsedEdgeProbe = z.infer<typeof EdgeProbeSchema>;
